import { toast } from "@/v2-ui/toast"
import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import { mapContentSheetHref } from "@/v2-backoffice-client/license/changes/license.changes.constants"
import { useContentDecisionWriter } from "@/v2-backoffice-client/license/changes/license.changes.decide.hooks"
import {
  isLockedContent,
  type LicenseContentItem,
} from "@/v2-backoffice-client/license/changes/license.content.utils"

export type LicenseContentRowToolbarProps = {
  item: LicenseContentItem
}

// The row's menu on the Content view: open the panel, and the one decision
// that needs no further input, "Free for everyone", for a package-only item
// that should open up again. Package-only needs the packages and the
// lock's blast radius in view, so it goes through the panel.
function LicenseContentRowToolbar(props: LicenseContentRowToolbarProps) {
  const { item } = props
  const { write, isSaving } = useContentDecisionWriter()
  const panelHref = mapContentSheetHref(item.Code)

  return (
    <ActionMenu>
      <ActionMenu.Trigger />
      <ActionMenu.Content>
        <ActionMenu.LinkItem
          iconSrc="expand"
          to={panelHref}
          data-feature-code="UI_BackofficeWhatsNewContent_Row_Open"
        >
          Open
        </ActionMenu.LinkItem>

        <ActionMenu.Separator />
        <ActionMenu.Item
          iconSrc="unlock"
          disabled={!isLockedContent(item)}
          isLoading={isSaving}
          data-feature-code="UI_BackofficeWhatsNewContent_Row_Free"
          onSelect={() => {
            void write(item.Code, "everyone").then((saved) => {
              if (saved) toast({ title: `${item.Name} is free for everyone.` })
            })
          }}
        >
          Free for everyone
        </ActionMenu.Item>
        <ActionMenu.LinkItem
          iconSrc="lock"
          to={panelHref}
          data-feature-code="UI_BackofficeWhatsNewContent_Row_Packages"
        >
          Package-only…
        </ActionMenu.LinkItem>
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default LicenseContentRowToolbar
